import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Welcome from './pages/Welcome';

const Services = lazy(() => import('./pages/Services'));
const MyWorks = lazy(() => import('./pages/MyWorks'));
const Contact = lazy(() => import('./pages/Contact'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
  return (
    <div className="app-container">
      <NavBar />
      <main>
        <Suspense fallback={<div className="page-loader" />}>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/services" element={<Services />} />
            <Route path="/my-works" element={<MyWorks />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

export default App;
